export const AuthAction = {
  setUser: "setUser", // user
  clearUser: "clearUser",
  setDeviceId: "setDeviceId",
  setTenantCode: "setTenantCode",
  setStaff: "setStaff",
  setLastLoginDateTime: "setLastLoginDateTime",
  logout: "logout",
  setGuest: "setGuest",
  clearGuest: "clearGuest",
  onNotifyMyself: "onNotifyMyself",
  isUserLoggedOut: "isUserLoggedOut",
  oneTimeToken: "oneTimeToken", // Using for PWA Admin sandbox feature
  userAgent: "userAgent",
  subscriptionEndpoint: "subscriptionEndpoint",
  setAccessToken: "setAccessToken",
  setRefreshToken: "setRefreshToken",
};

export const AuthMutation = {
  SET_USER: "SET_USER",
  CLEAR_USER: "CLEAR_USER",
  SET_DEVICE_ID: "SET_DEVICE_ID",
  SET_TENANT_CD: "SET_TENANT_CD",
  SET_STAFF: "SET_STAFF",
  SET_LAST_LOGIN_DATETIME: "LAST_LOGIN_DATETIME",
  SET_GUEST: "SET_GUEST",
  CLEAR_GUEST: "CLEAR_GUEST",
  LOGOUT: "LOGOUT",
  SET_IS_USER_LOGGED_OUT: "SET_IS_USER_LOGGED_OUT",
  SET_ONE_TIME_TOKEN: "SET_ONE_TIME_TOKEN",
  SET_USER_AGENT: "SET_USER_AGENT",
  SET_SUBSCRIPTION_ENDPOINT: "SET_SUBSCRIPTION_ENDPOINT",
  SET_ACCESS_TOKEN: "SET_ACCESS_TOKEN",
  SET_REFRESH_TOKEN: "SET_REFRESH_TOKEN",
};
